export default __webpack_public_path__ + "static/media/Hcp_insights_logo.78c40864.png";